import React from 'react';
import CmtVertical from '../../../../../@coremat/CmtNavigation/Vertical';
import PerfectScrollbar from 'react-perfect-scrollbar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IntlMessages from '../../../../utils/IntlMessages';
import { PostAdd } from '@material-ui/icons';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import AssessmentIcon from '@material-ui/icons/Assessment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import PageviewIcon from '@material-ui/icons/Pageview';
import { useSelector } from 'react-redux';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import ShareIcon from '@material-ui/icons/Share';
import SettingsIcon from '@material-ui/icons/Settings';
import ListIcon from '@material-ui/icons/List';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import * as appConstants from "../../../../../Constants/AppConstants";
import TwitterIcon from '@material-ui/icons/Twitter';
import NotificationsIcon from '@material-ui/icons/Notifications';

const useStyles = makeStyles(theme => ({
  perfectScrollbarSidebar: {
    height: '100%',
    transition: 'all 0.3s ease',
    '.Cmt-sidebar-fixed &, .Cmt-Drawer-container &': {
      height: 'calc(100% - 167px)',
    },
    '.Cmt-modernLayout &': {
      height: 'calc(100% - 72px)',
    },
    '.Cmt-miniLayout &': {
      height: 'calc(100% - 91px)',
    },
    '.Cmt-miniLayout .Cmt-sidebar-content:hover &': {
      height: 'calc(100% - 167px)',
    },
  },
}));

const SideBar = () => {
  const classes = useStyles();
  const { userSubscription } = useSelector(({ firebaseStore }) => firebaseStore);
  const { authUser } = useSelector(({ auth }) => auth);

  var navigationMenus = [
    {
      name: <IntlMessages id={'sidebar.main'} />,
      type: 'section',
      children: [],
    },
  ];

  if (authUser !== null && authUser.isAdmin === true) {
    navigationMenus.push({
      name: <IntlMessages id={'sidebar.admin'} />,
      type: 'section',
      children: [],
    });

    navigationMenus[1].children.push({
      name: <IntlMessages id={'pages.users'} />,
      icon: <PeopleAltIcon />,
      type: 'item',
      link: '/admin/users',
    });

    navigationMenus[1].children.push({
      name: <IntlMessages id={'pages.stockTwitFilters'} />,
      icon: <svg width="24" height="24" viewBox="0 0 172.000000 172.000000" className="svgIconSideBar makeStyles-iconRoot-61 Cmt-icon-root">
        <g transform="translate(0.000000,172.000000) scale(0.100000,-0.100000)">
          <path d="M852 1261 c-134 -70 -247 -132 -253 -138 -6 -6 -9 -30 -7 -54 l3 -44
      255 -132 c140 -73 258 -133 263 -133 4 0 7 38 7 85 l0 86 -152 73 -153 73 153
      73 152 73 0 84 c0 60 -3 83 -12 82 -7 0 -122 -58 -256 -128z"></path>
          <path d="M600 843 l0 -80 153 -72 c127 -61 149 -74 136 -84 -9 -7 -77 -41
      -152 -77 l-136 -65 0 -77 c-1 -43 2 -78 7 -78 4 1 117 59 252 130 l245 129 3
      48 2 48 -245 125 c-135 69 -250 127 -255 128 -6 2 -10 -30 -10 -75z"></path>
        </g>
      </svg>,
      type: 'item',
      link: '/admin/stocktwit-filters',
    });

    navigationMenus[1].children.push({
      name: <IntlMessages id={'pages.sharingfilters'} />,
      icon: <TwitterIcon />,
      type: 'item',
      link: '/admin/sharing-filters',
    });

    navigationMenus[1].children.push({
      name: <IntlMessages id={'pages.discordfilters'} />,
      icon: <svg width="24" height="24" viewBox="0 0 256 293" className="svgIconSideBar makeStyles-iconRoot-61 Cmt-icon-root">
      <g>
          <path d="M226.011429,0 L29.9885714,0 C13.4582857,0 0,13.4582857 0,30.1348571 L0,227.913143 C0,244.589714 13.4582857,258.048 29.9885714,258.048 L195.876571,258.048 L188.123429,230.985143 L206.848,248.393143 L224.548571,264.777143 L256,292.571429 L256,30.1348571 C256,13.4582857 242.541714,0 226.011429,0 Z M169.545143,191.049143 C169.545143,191.049143 164.278857,184.758857 159.890286,179.2 C179.053714,173.787429 186.368,161.792 186.368,161.792 C180.370286,165.741714 174.665143,168.521143 169.545143,170.422857 C162.230857,173.494857 155.209143,175.542857 148.333714,176.713143 C134.290286,179.346286 121.417143,178.614857 110.445714,176.566857 C102.107429,174.957714 94.9394286,172.617143 88.9417143,170.276571 C85.5771429,168.96 81.92,167.350857 78.2628571,165.302857 C77.824,165.010286 77.3851429,164.864 76.9462857,164.571429 C76.6537143,164.425143 76.5074286,164.278857 76.3611429,164.132571 C73.728,162.669714 72.2651429,161.645714 72.2651429,161.645714 C72.2651429,161.645714 79.2868571,173.348571 97.8651429,178.907429 C93.4765714,184.466286 88.064,191.049143 88.064,191.049143 C55.7348571,190.025143 43.4468571,168.813714 43.4468571,168.813714 C43.4468571,121.709714 64.512,83.5291429 64.512,83.5291429 C85.5771429,67.7302857 105.618286,68.1691429 105.618286,68.1691429 L107.081143,69.9245714 C80.7497143,77.5314286 68.608,89.088 68.608,89.088 C68.608,89.088 71.8262857,87.3325714 77.2388571,84.8457143 C92.8914286,77.9702857 105.325714,76.0685714 110.445714,75.6297143 C111.323429,75.4834286 112.054857,75.3371429 112.932571,75.3371429 C121.856,74.1668571 131.949714,73.8742857 142.482286,75.0445714 C156.379429,76.6537143 171.300571,80.7497143 186.514286,89.088 C186.514286,89.088 174.957714,78.1165714 150.089143,70.5097143 L152.137143,68.1691429 C152.137143,68.1691429 172.178286,67.7302857 193.243429,83.5291429 C193.243429,83.5291429 214.308571,121.709714 214.308571,168.813714 C214.308571,168.813714 201.874286,190.025143 169.545143,191.049143 Z M101.522286,122.733714 C93.184,122.733714 86.6011429,130.048 86.6011429,138.971429 C86.6011429,147.894857 93.3302857,155.209143 101.522286,155.209143 C109.860571,155.209143 116.443429,147.894857 116.443429,138.971429 C116.589714,130.048 109.860571,122.733714 101.522286,122.733714 M154.916571,122.733714 C146.578286,122.733714 139.995429,130.048 139.995429,138.971429 C139.995429,147.894857 146.724571,155.209143 154.916571,155.209143 C163.254857,155.209143 169.837714,147.894857 169.837714,138.971429 C169.837714,130.048 163.254857,122.733714 154.916571,122.733714"></path>
      </g>
  </svg>,
      type: 'item',
      link: '/admin/discord-filters',
    });

    navigationMenus[1].children.push({
      name: <IntlMessages id={'pages.manualNotifications'} />,
      icon: <NotificationsIcon />,
      type: 'item',
      link: '/admin/manual-notifications',
    });
  }

  navigationMenus[0].children.push(
    {
      name: <IntlMessages id={'pages.dashboard'} />,
      icon: <PostAdd />,
      type: 'item',
      link: '/dashboard',
    },
    {
      name: <IntlMessages id={'pages.mobileDashboard'} />,
      icon: <PhoneAndroidIcon />,
      type: 'item',
      link: '/mobile-dashboard',
    });

    navigationMenus[0].children.push({
      name: <IntlMessages id={'pages.watchlist'} />,
      icon: <VisibilityIcon />,
      type: 'item',
      link: '/watchlist',
    },{
      name: <IntlMessages id={'pages.chart'} />,
      icon: <AssessmentIcon />,
      type: 'item',
      link: '/chart',
    },
    {
      name: <IntlMessages id={'pages.summary'} />,
      icon: <AssessmentIcon />,
      type: 'item',
      link: '/summary',
    },
    {
      name: <IntlMessages id={'pages.analysis'} />,
      icon: <PageviewIcon />,
      type: 'item',
      link: '/analysis',
    },
    {
      name: <IntlMessages id={'pages.learningCenter'} />,
      icon: <LiveHelpIcon />,
      type: 'item',
      link: '/learning-center',
    });

  if (userSubscription !== null && userSubscription.role === appConstants.Role_Customer) {
    navigationMenus[0].children.push({
        name: <IntlMessages id={'pages.alert'} />,
        icon: <NotificationsActiveIcon />,
        type: 'item',
        link: '/alert',
      }
    );
  }
  else if(userSubscription !== null && userSubscription.role === appConstants.Role_Discord)
  {
    navigationMenus[0].children.push(
      {
        name: <IntlMessages id={'pages.discordServers'} />,
        icon: <SettingsApplicationsIcon />,
        type: 'item',
        link: '/discord-servers',
      });
      
    navigationMenus[0].children.push(
      {
        name: <IntlMessages id={'pages.discord'} />,
        icon: <SettingsIcon />,
        type: 'item',
        link: '/discord-settings',
      });

      navigationMenus[0].children.push(
        {
          name: <IntlMessages id={'pages.discordInstructions'} />,
          icon: <ListIcon />,
          type: 'item',
          link: '/discord-instructions',
        });
  }

  return (
    <PerfectScrollbar className={classes.perfectScrollbarSidebar}>
      <CmtVertical menuItems={navigationMenus} />
    </PerfectScrollbar>
  );
};

export default SideBar;